import { render } from "./Gatilho.vue?vue&type=template&id=6a883cae&scoped=true"
import script from "./Gatilho.vue?vue&type=script&lang=js"
export * from "./Gatilho.vue?vue&type=script&lang=js"

import "./Gatilho.vue?vue&type=style&index=0&id=6a883cae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a883cae"]])

export default __exports__